




















































































import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import { AuthModule, SurveyModule } from "@/store";
import { SurveyType, Term } from "@/interfaces";
import { QVirtualScroll } from "quasar";
import HelpDialog from "./HelpDialog.vue";

@Component
export default class MenuRight extends Vue {
  @Ref("virtualListRef")
  virtualScrollList!: QVirtualScroll;

  @Prop({ type: Boolean, default: () => false })
  value!: boolean;

  @AuthModule.bindings.Getter
  isAdministrator!: boolean;

  @SurveyModule.bindings.State
  type!: SurveyType;

  @SurveyModule.bindings.State
  loadingPreSurvey!: boolean;

  @SurveyModule.bindings.State
  termsBySection!: Term[];

  @SurveyModule.bindings.State
  scrollToTerm!: string;

  termsBySectionFiltered: Term[] = [];

  searchText = "";

  mounted() {
    this.onSurveyTypeChange();
  }

  toggleMenu() {
    this.$emit("input", !this.value);
  }

  termSearchSubmit() {
    if (this.searchText !== "") {
      this.termsBySectionFiltered = this.termsBySection.filter(term =>
        term.title.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.termsBySectionFiltered = this.termsBySection;
    }
  }

  openHelpDialog() {
    this.$q.dialog({
      component: HelpDialog,
      parent: this,
    });
  }

  @Watch("type")
  async onSurveyTypeChange() {
    try {
      if (this.type !== null) {
        await SurveyModule.store.getPreSurvey(this.type);
        this.termsBySectionFiltered = this.termsBySection;
      } else {
        SurveyModule.store.setTermsBySection([]);
      }
    } catch (error) {
      console.log(error);
    }
  }

  @Watch("scrollToTerm")
  async onScrollToTermChange() {
    if (this.scrollToTerm !== "") {
      this.$emit("input", true);
      this.searchText = "";
      this.termsBySectionFiltered = this.termsBySection;
      const index = this.termsBySectionFiltered.findIndex(
        term => term.title.toLowerCase() === this.scrollToTerm.toLowerCase().trim(),
      );

      if (index !== -1) {
        this.virtualScrollList.scrollTo(index);
      }

      SurveyModule.store.setScrollToTerm("");
    }
  }
}
